import { render, staticRenderFns } from "./DashboardQuestions.vue?vue&type=template&id=47c122d2&scoped=true&"
import script from "./DashboardQuestions.vue?vue&type=script&lang=js&"
export * from "./DashboardQuestions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardQuestions.vue?vue&type=style&index=0&id=47c122d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c122d2",
  null
  
)

export default component.exports